import fetchWrapper from '@/api/fetch-wrapper';

const API_URL = '/local/components/zetta/calculator.eipoteka/ajax.php';

export const calculatorEipoteka = (action, headers) => {
    const query = `${API_URL}?action=${action}`;

    return fetchWrapper.get(query, null, headers);
}

export const calculatorEipotekaPost = (action, body = null, headers = null) => {
  const query = `${API_URL}`;

  body.action = action;

  return fetchWrapper.post(query, body, headers);
}

export const validateCoupon = (coupon) => {
    const body = {
        type: 'E_IPOTEKI',
        action: 'getCoupon',
        coupon
    }

    const query = `${API_URL}`;

    return fetchWrapper.post(query, body);
}

export const getFioByString = (fio, headers) => {
    const query = `${API_URL}?fio=${fio}&action=getDadataFioAction`;

    return fetchWrapper.get(query, null, headers);
}

export const getAddressByString = (address, headers) => {
    const query = `${API_URL}?address=${address}&action=getDadataAddressAction`;

    return fetchWrapper.get(query, null, headers);
}

export const getIssuedByPassport = (code, headers) => {
    const query = `${API_URL}?code=${code}&action=getPassportDataAction`;

    return fetchWrapper.get(query, null, headers);
}
